import * as angular from 'angular';
import { ComponentDefinition } from '../../models/ComponentDefinition';
import { ISupportDetails } from '../../services';

class WidetechInformationController implements angular.IComponentController {
    details: ISupportDetails;

    static $inject = [];

    $onInit() {
        if (!this.details) {
            this.details = {} as any;
        }
    }
}

export const wtWidetechInformation: ComponentDefinition = {
    componentId: 'wtWidetechInformation',
    controller: WidetechInformationController,
    controllerAs: 'vm',
    template: require('./widetechInformation.component.html'),
    bindings: {
        details: '<?'
    }
};
